var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.91242 5.7083C6.20737 3.83705 9.07135 2.60341 10.5044 2.00738C14.5959 0.30558 15.446 0.00996026 16.0002 9.46359e-05C16.122 -0.00194823 16.3945 0.0282562 16.5711 0.171489C16.7201 0.292432 16.7611 0.455809 16.7808 0.570476C16.8004 0.685143 16.8248 0.946358 16.8054 1.15046C16.5837 3.48009 15.6243 9.13349 15.1362 11.7427C14.9297 12.8468 14.523 13.217 14.1293 13.2532C13.2738 13.3319 12.6241 12.6878 11.7954 12.1446C10.4987 11.2946 9.76619 10.7654 8.50753 9.936C7.05292 8.97744 7.99588 8.4506 8.82486 7.58959C9.04181 7.36426 12.8115 3.93546 12.8844 3.62441C12.8936 3.58551 12.902 3.44051 12.8159 3.36394C12.7297 3.28737 12.6026 3.31355 12.5108 3.33438C12.3808 3.36389 10.3093 4.73307 6.29639 7.4419C5.70841 7.84565 5.17583 8.04237 4.69866 8.03207C4.17262 8.0207 3.16072 7.73463 2.40848 7.49011C1.48583 7.19019 0.752522 7.03162 0.816376 6.52227C0.849636 6.25697 1.21498 5.98564 1.91242 5.7083Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.925bc2fcf9e9b6f8145df749f17b580b.svg";
export { ForwardRef as ReactComponent };